<template>
  <article class="ut-mb-12 ut--mx-4 sm:ut-mx-auto">
    <h2 class="ut-text-xl ut-font-semibold ut-mb-6 ut-mx-4 sm:ut-mx-auto">Activity</h2>
    <div v-if="!loading && activities.length > 0" class="ut-card-base">
      <prospect-activity-item v-for="(activity, index) in activities"
          :key="index"
          :data="activity.data"
          :contact="contact"
          :date="activity.dateFormatted"
          :type="activity.prospectActivityTypeId"/>
    </div>
    <div v-if="!loading && activities.length < 0" class="ut-card-base">
      <p>No activity found</p>
    </div>
    <loading-spinner v-if="loading" />
  </article>
</template>

<script>
import ProspectActivityItem from '@/components/Prospecting/ProspectActivityItem.vue';
import LoadingSpinner from '@/components/Animations/LoadingSpinner.vue';

export default {
  name: 'ProspectActivitySection',
  components: {
    ProspectActivityItem,
    LoadingSpinner,
  },
  props: {
    activities: {
      type: Array,
      required: true,
    },
    contact: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {

    };
  },
  computed: {

  },
  mounted() {
    if (this.$route.query.moreinfo) {
      this.gotoOAMatchInfo();
    }
  },
  methods: {
    gotoOAMatchInfo() {
      if(this.activities.length > 0) {
        this.$scrollTo('.more-info', 0, { easing: 'ease', cancelable: false });
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
